import { render } from "./VirtualServiceGateways.vue?vue&type=template&id=abdf9e54"
import script from "./VirtualServiceGateways.vue?vue&type=script&lang=js"
export * from "./VirtualServiceGateways.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__